export default __webpack_public_path__ + "static/media/Clock Start Jingle.5043367b.mp3";